import { h, Component } from 'preact';
import { Router } from 'preact-router';

import Toolbar from 'preact-material-components/Toolbar';
import TextField from 'preact-material-components/TextField';
import Icon from 'preact-material-components/Icon';
import List from 'preact-material-components/List';
import 'preact-material-components/Toolbar/style.css';
import 'preact-material-components/TextField/style.css';
import 'preact-material-components/Icon/style.css';
import 'preact-material-components/List/style.css';
import './style';

class WordRow extends Component {
  render() {
    const word = this.props.word;
    const meanings = word.meanings.map((m) =>
<List.Item style="padding-left: 2em">
  <List.PrimaryText>{m}</List.PrimaryText>
</List.Item>
);
	const pron = word.pronounciation ? (
		<List.PrimaryText>{word.pronounciation}</List.PrimaryText>) : '';
    return (
<div>
 <List.Item>
  <List.SecondaryText>{word.wanted}</List.SecondaryText>
  {pron}
 </List.Item>
 {meanings} 
</div>
    );
  }
}

class WordTable extends Component {
  constructor(props) {
    super(props);
    this.state = { 
		resultsFor: '', 
		list: null
	};
	this.slovnik = new Slovnik();
	var q = props.filterText == null ? '' : props.filterText;
	this.slovnik.search(q,this,function(ctx,data) {
    	ctx.setState({ resultsFor: q, list: data });
	});
  }
  componentWillUpdate(nextProps,nextState) {
	this.slovnik.search(nextProps.filterText,this,function(ctx,data) {
    	ctx.setState({ resultsFor: nextProps.filterText,
			           list: data });
	});
  }
  render() {
	if(this.state.list == null) return (
<center style="color: gray">
		<Icon style="font-size: 120px">cloud_download</Icon>
		<div>Loading dictionary...</div>
</center>
	);

    const filterText = this.props.filterText;
    const inStockOnly = this.props.inStockOnly;

	var list = this.state.list;
    const rows = [];
	for(var i=0;i<list.length;i++) {
		var word = list[i];
		rows.push(
          <WordRow word={word} key={i} />
		);
	}
    return (
<div>
<List>{rows}</List>
</div>
    );
  }
}

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
    this.handleInStockChange = this.handleInStockChange.bind(this);
  }

  handleFilterTextChange(e) {
//	Router('/'+e.target.value);
    this.props.onFilterTextChange(e.target.value);
  }

  handleInStockChange(e) {
    this.props.onInStockChange(e.target.checked);
  }

  render() {
    return (
<Toolbar.Row>
 <Toolbar.Section align-start>
  <Toolbar.Icon>done_all</Toolbar.Icon>
  <TextField style="color:white"
     placeholder="Search..."
     value={this.props.filterText}
     fullwidth={true}
     box={true}
     onChange={this.handleFilterTextChange}
     onKeyDown={this.handleFilterTextChange}
     onKeyUp={this.handleFilterTextChange}
  />
 </Toolbar.Section>
</Toolbar.Row>
    );
  }
}

class FilterableWordTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterText: this.props.filterText,
      inStockOnly: false
    };

    this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
    this.handleInStockChange = this.handleInStockChange.bind(this);
  }

  handleFilterTextChange(filterText) {
    this.setState({
      filterText: filterText
    });
  }

  handleInStockChange(inStockOnly) {
    this.setState({
      inStockOnly: inStockOnly
    })
  }

  render({}) {
    return (
<div>
 <Toolbar className="toolbar">
    <SearchBar
       filterText={this.state.filterText}
       inStockOnly={this.state.inStockOnly}
       onFilterTextChange={this.handleFilterTextChange}
       onInStockChange={this.handleInStockChange}
    />
 </Toolbar>
 <WordTable
    filterText={this.state.filterText}
    inStockOnly={this.state.inStockOnly}
 />
</div>
    );
  }
}

class SearchRoute extends Component {
    render({ word }, {}) {
        return (
<FilterableWordTable filterText={word} />
        );
    }
}

let slovnik = null;

class Slovnik {
	constructor() {
		if(!slovnik) slovnik = this;
		slovnik.ondata = []; // functions to call when data are available
		fetch('assets/dict/czen.v1.txt').then(
			function(response) {
				if(response.status !== 200)
					return alert(response.status);
				response.text().then(function(text) {
					slovnik.data = text.split('\n');
					slovnik.last = '';
					slovnik.offset = 0;
					slovnik.performSearches();
				});
   			 }
		).catch(function(err) {
			alert('Failed to fetch dictionary. '+err);
		});
        return slovnik;
	}

	entry(line) {
		// Alexandria{.ælɪg'za:ndrɪə}æləgzændriə%Alexandria%Alexandrie
		var meanings = line.split('%');
		var wp = [meanings.shift()];
		return {
			wanted: wp[0],
			pronounciation: wp[1], // ne vzdy
			meanings: meanings,
		}
	}

	doSearch(q) {
		var cmps = 0;
		var found = []; // muzeme pulit interval nebo si pamatovat offset
		if(!this.last.startsWith(q)) {
			this.last = ''; this.offset = 0;
		}
		for(var i=this.offset;i<this.data.length;i++) {
			if(this.data[i].startsWith(q)) found.push(this.entry(this.data[i]));
//			else { if(found.length) break } // uz nezacina - skonci
			if(found.length > 50) break;
			cmps++;
		}
		console.log("doSearch('"+q+"') found "+found.length+
							" words using "+cmps+" comparisions");
		return found;
	}
	performSearches() {
		if(this.ondata.length) { // vlastne staci posledni...
			var search = this.ondata[this.ondata.length-1];
			search.fn(search.ctx,this.doSearch(search.q));
		}
		this.ondata = []; // hotovo
	}

	search(q,ctx,fn) {
		this.ondata.push({ q: q, ctx: ctx, fn: fn });
		if(this.data) this.performSearches();
	}
}
export default class App extends Component {
  render() {
	return (
<Router onChange={this.handleRoute}>
 <SearchRoute path="/" />
 <SearchRoute path="/:word" />
</Router>
	);
  }
}




// WEBPACK FOOTER //
// ./index.js